import { Loader } from '@googlemaps/js-api-loader'

/**
 * geocoderAPIに住所を投げて結果を一つ返す
 */
const getGeocoderResult: (params: {
  apiKey: string
  address: string
  onGetResult: (result: google.maps.GeocoderResult) => void
  onError: (error: Error) => void
}) => Promise<void> = ({ apiKey, address, onGetResult, onError }) => {
  const loader = new Loader({
    apiKey,
    version: 'weekly',
  })

  return new Promise<void>((_, reject) => {
    // Google Maps API の認証エラーを検知するコールバック
    ;(window as Window & { gm_authFailure?: () => void }).gm_authFailure =
      () => {
        const authError = new Error(
          'Google Maps API authentication failed. Please check your API key.'
        )
        console.error(authError)
        onError(authError)
        reject(authError)
      }

    loader
      .load()
      .then(() => {
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === 'OK') {
            onGetResult(results[0])
          } else {
            throw new Error(
              'Geocode was not successful for the following reason: ' + status
            )
          }
        })
      })
      .catch((e) => {
        console.error(e)
        onError(e)
        reject(e)
      })
  })
}

export default getGeocoderResult
